const DOCUMENTATION_LINK =
  'https://support.thinkific.dev/hc/en-us/articles/4422678799767';
const TOAST_TIME = 5000;

export { DOCUMENTATION_LINK, TOAST_TIME };
